import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { Page404Component } from './page404.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
export { Page404Component } from './page404.component';
@NgModule({
  declarations: [Page404Component],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forChild(),
    FlexLayoutModule,
    MatButtonModule,
  ],
  exports: [Page404Component],
})
export class Page404Module {}
